const DOWNLOAD_ERROR_FALLBACK = 'Unable to download the resume. Please try again.'

// A failed bulk-download still arrives as a Blob whenever the request opted into
// responseType:'blob', so the JSON error body (e.g. the 422 raised when a
// candidate has no uploaded CV) has to be read out of the Blob before it can be
// shown. Falls back to a generic message for network errors / unparseable bodies.
export const readDownloadErrorMessage = async error => {
  const data = error?.response?.data ?? error?.data
  try {
    if (data instanceof Blob) {
      const parsed = JSON.parse(await data.text())
      return parsed?.message || DOWNLOAD_ERROR_FALLBACK
    }
    return data?.message || error?.message || DOWNLOAD_ERROR_FALLBACK
  } catch (parseError) {
    console.error('Failed to parse resume download error body:', parseError)
    return DOWNLOAD_ERROR_FALLBACK
  }
}

export const singlePdf = async(response,studentName,studentId)=>{
    // const res = await studentRequest.get(`/students/${studentId}`)
    // const cvUrlTYPE = res?.data?.data?.cvUrl?.type || 'pdf'
//     const blob = new Blob([response], { type: 'application/pdf' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `${studentName} resume.pdf`;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//    return window.URL.revokeObjectURL(url);

    const disposition = response.headers?.['content-disposition'] || '';
  console.log('disposition:', disposition);
  
  // Extract filename
  const match = disposition.match(/filename="?(.+?)"?$/);
  const originalFilename = match ? match[1] : 'resume.pdf';
  console.log('originalFilename:', originalFilename);
  
  // Get extension from filename
  const ext = originalFilename.split('.').pop().toLowerCase();
  console.log('ext:', ext);

  const mimeTypes = {
    'pdf': 'application/pdf',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  };

  // Fall back to pdf when the parsed extension isn't a known resume type
  // (e.g. content-disposition filename had no extension), so the download
  // never ends up with a missing/garbled extension like "resume_" instead
  // of "resume_.pdf".
  const safeExt = mimeTypes[ext] ? ext : 'pdf';
  const mimeType = mimeTypes[safeExt];

  const blob = new Blob([response.data], { type: mimeType });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${studentName} resume.${safeExt}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  
  return window.URL.revokeObjectURL(url);
}


export const zipFile = async(response) =>{
    const blob = new Blob([response], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Download_Resumes.zip';
    document.body.appendChild(a);
    a.click();
    a.remove();
   return window.URL.revokeObjectURL(url);
}